/* RESPONSIBLE TEAM: team-knowledge-foundations */

import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class SubheaderStyle extends Fragment {
  @attr('string') declare backgroundColor: string;
  @attr('string') declare fontColor: string;
}
